import { createContext, useContext } from 'react';
import { grid_dark_theme } from 'framework/Grid/hooks/constants';

import { GridContextProps } from '../types';

export const GridContext = createContext<GridContextProps<any>>({
  headers: [],
  columns: [],
  summary: [],
  column_widths: [],
  cumulative_column_widths: [],
  cumulative_fixed_left_widths: [],
  cumulative_fixed_right_widths: [],
  visible_rows: [],
  column_filters: [],
  start_index: 0,
  total_columns_width: 1000,
  header_height: 34,
  header_clamp: 2,
  row_height: 34,
  filler_width: 0,
  overscan: 5,
  velocity: 1,
  is_scrolling: false,
  height: 0,
  width: 0,
  depth: 1,
  filler_required: false,
  theme: { ...grid_dark_theme },
  filterColumn: () => {},
  setColumns: () => {},
  setColumnSortDirection: () => {},
  updateColumnSortDirection: () => {},
  moveColumn: () => {},
  resizeColumn: () => {},
});

export const useGridContext = <T extends Record<string, any>>() =>
  useContext(GridContext) as GridContextProps<T>;
